// Config precedence: runtime window.__CONFIG__ (served by Express /config.js in
// deployments) > build-time REACT_APP_* (from frontend/.env for local dev) >
// placeholder tokens (last resort, non-functional).
const runtimeConfig =
  (typeof window !== 'undefined' && window.__CONFIG__) || {};

const pick = (runtimeValue, envValue, fallbackValue) =>
  runtimeValue || envValue || fallbackValue;

const config = {
  apiBaseUrl: pick(
    runtimeConfig.apiBaseUrl,
    process.env.REACT_APP_APP_BASE_URL,
    '/donuts/:stage:/SIPVIEWER-API_BASE_URL'
  ),
  rcApiBaseUrl: pick(
    runtimeConfig.rcApiBaseUrl,
    process.env.REACT_APP_RC_BASE_API_URL,
    '/donuts/:stage:/SIPVIEWER-RC_API_BASE_URL'
  ),
  rcApiInternalUrl: pick(
    runtimeConfig.rcApiInternalUrl,
    process.env.REACT_APP_RC_API_INTERNAL_URL,
    '/donuts/:stage:/SIPVIEWER-RC_API_INTERNAL_URL'
  ),
  rc_client_Id: pick(
    runtimeConfig.rc_client_Id,
    process.env.REACT_APP_RC_CLIENT_ID,
    '/donuts/:stage:/SIPVIEWER-CLIENT_ID'
  ),
  rc_authorize_uri: pick(
    runtimeConfig.rc_authorize_uri,
    process.env.REACT_APP_RC_AUTHORIZE_URL,
    '/donuts/:stage:/SIPVIEWER-RC_AUTHORIZE_URI'
  ),
  rc_jwks_url: pick(
    runtimeConfig.rc_jwks_url,
    process.env.REACT_APP_JWKS_URL,
    '/donuts/:stage:/SIPVIEWER-JWKS_URL'
  ),
  redirectUrl: pick(
    runtimeConfig.redirectUrl,
    process.env.REACT_APP_REDIRECT_URL,
    '/donuts/:stage:/SIPVIEWER-REDIRECT_URL'
  ),
  jwksAppName: {
    production: pick(
      runtimeConfig.jwksAppName && runtimeConfig.jwksAppName.production,
      process.env.REACT_APP_JWKS_APP_NAME,
      '/donuts/:stage:/SIPVIEWER-JWKS_APP_NAME'
    ),
    sandBox: pick(
      runtimeConfig.jwksAppName && runtimeConfig.jwksAppName.sandBox,
      process.env.REACT_APP_JWKS_SANDBOX_APPNAME,
      '/donuts/:stage:/SIPVIEWER-JWKS_SANDBOX_APPNAME'
    ),
  },
};

module.exports = config;
